import { RoutesPaths } from "../../../constants/routes.ts"
import { type PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"
import {
  type ProjectSectionKeys,
  getVisibleProjectTabs
} from "./project-visible-tabs.ts"

export const projectManagementTabPath = (
  id: string,
  tab: ProjectSectionKeys
): string => {
  const value = RoutesPaths.project.view(id)[tab]
  return typeof value === "function" ? value() : value
}

/**
 * The concrete Project Management URL to send a user to — the first tab their
 * permissions actually let them see, never a hardcoded one. A subcontractor
 * with no `project_milestone_view` clicking a Milestones-shaped link used to
 * land on Access Restricted; this is the one place that decision is made.
 *
 * Returns null when nothing is visible, so a caller can disable the button
 * instead of navigating into a dead end.
 */
export const getFirstVisibleProjectManagementRoute = (
  permissions: PermissionProjectPermissions | undefined,
  roleId: number | null | undefined,
  id: string
): string | null => {
  const [firstVisibleTab] = getVisibleProjectTabs(permissions, roleId)
  return firstVisibleTab ? projectManagementTabPath(id, firstVisibleTab) : null
}
